import { getCampaignPreview, getWidgetUnits } from 'api/widget';
import { GetWidgetUnitsConfig } from 'api/widget/types';
import { WidgetDispatch } from './types';

export async function loadWidgetData(
  dispatch: WidgetDispatch,
  widgetId: string,
  config: GetWidgetUnitsConfig = {},
): Promise<void> {
  dispatch({ type: 'WIDGET_DATA_LOAD_REQUEST' });

  try {
    const result = await getWidgetUnits(widgetId, config);
    dispatch({
      type: 'WIDGET_DATA_LOAD_SUCCESS',
      payload: result,
    });
  } catch {
    dispatch({ type: 'WIDGET_DATA_LOAD_FAILURE' });
  }
}

export async function loadCampaignWidgetData(
  dispatch: WidgetDispatch,
  campaignFeedId: number,
): Promise<void> {
  dispatch({ type: 'WIDGET_DATA_LOAD_REQUEST' });

  try {
    const result = await getCampaignPreview(campaignFeedId);
    dispatch({
      type: 'WIDGET_DATA_LOAD_SUCCESS',
      payload: result,
    });
  } catch {
    dispatch({ type: 'WIDGET_DATA_LOAD_FAILURE' });
  }
}
